<template>
    <div>
      <van-nav-bar
        title="修改登录密码"
        left-text="返回"
        left-arrow
        @click-left="$router.push('/member/information')"
      />
      <van-form @submit="onSubmit">
        <van-field
          v-model="user.phone"
          name="phone"
          label="手机号"
          placeholder="手机号"
          readonly
        />
        <van-field
          v-model="rePicCode"
          center
          clearable
          label="验证码"
          placeholder="请输入验证码"
        >
          <div slot="button">
            <img
              :src="captcha"
              @click="this.getCaptcha"
              style="height: 25px; width: 80px"
            />
          </div>
        </van-field>
        <van-field
          v-model="sms"
          center
          clearable
          label="短信验证码"
          placeholder="请输入短信验证码"
          :rules="[{ required: true, message: '请填写验证码' }]"
        >
          <template #button>
            <van-button native-type="button" size="small" plain type="info" @click="getLoginCode" :disabled="disabled">{{getCodeText}}</van-button>
          </template>
        </van-field>
        <van-field
          v-model="loginPass"
          type="password"
          name="loginPass"
          label="输入密码"
          placeholder="输入密码"
          :rules="[{ required: true, message: '请输入密码' }]"
        />
        <van-field
          v-model="confirmPass"
          type="password"
          name="confirmPass"
          label="确认密码"
          placeholder="确认密码"
          :rules="[{ required: true, message: '请输入确认密码' }]"
        />
        <div style="margin: 16px;">
          <van-button round block type="danger" size="small" native-type="submit">
            确定
          </van-button>
        </div>
      </van-form>
    </div>
</template>

<script>
import JSEncrypt from "jsencrypt/bin/jsencrypt";
    export default {
      name: "LoginPass",
      data(){
        return{
          sms:'',
          loginPass:'',
          confirmPass:'',
          disabled:false,
          getCodeText:'获取验证码',
          captcha: "",
          verify_token:"",
          rePicCode:"",
        }
      },
      computed:{
        phone:function () {
          return this.$store.state.phone
        },
        user:function () {
          return this.$store.state.user
        }
      },
      methods:{
        getCaptcha() {
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "getSmsPic",
              },
            })
            .then(function (res) {
              let resData = res.data;
              if (resData.code == 1) {
                that.captcha = resData.data.code_url;
                that.verify_token = resData.data.verify_token;
              } else if (resData.code == 0) {
                that.disabled = false;
                that.$toast.fail(res.data.msg);
              }
            });
        },
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        onSubmit(){
          let that = this;
          if (that.loginPass === that.confirmPass){
            let publicKey = localStorage.getItem("encript_public_key");
            let loginPassword = that.encryptMessage(that.loginPass, publicKey);
            let confirmPassword = that.encryptMessage(that.confirmPass, publicKey);
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "modify_login_e",
                  token: sessionStorage.getItem("token"),
                  password: loginPassword,
                  confirm: confirmPassword,
                  code: that.sms
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                  that.$store.commit("changeLoginType", false);
                  sessionStorage.removeItem("token");
                  sessionStorage.removeItem("loginType");
                  that.$toast.success({
                    message: res.data.msg,
                    onClose:function () {
                      that.$router.push({
                        path: "/login"
                      });
                    }
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$toast.fail(res.data.msg);
                }
              });
          }else{
            that.$toast.fail('密码不一致,请重新输入');
          }
        },
        getLoginCode() {
          let that = this;
          clearInterval(window.timer2);
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "modifyInfo_code_e",
                token: sessionStorage.getItem("token"),
                info: "",
                type: 0,
                rePicCode:that.rePicCode,
                verify_token:that.verify_token,
              }
            })
            .then(function(res) {
              if (res.data.code == 1) {
                that.$toast.success({
                  message: res.data.msg,
                });
                var time = 60;
                that.disabled = true;
                that.getCodeText = time + "s";
                window.timer2 = setInterval(function() {
                  time--;
                  that.getCodeText = time + "s";
                  if (time <= 0) {
                    clearInterval(window.timer2);
                    that.disabled = false;
                    that.getCodeText = "获取验证码";
                  }
                }, 1000);
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            });
        },
        encryptMessage(message, publicKey) {
          const jsEncrypt = new JSEncrypt();
          jsEncrypt.setPublicKey(publicKey);
          return jsEncrypt.encrypt(message);
        },
      },
      mounted:function () {
        this.isLogin();
        this.getCaptcha();
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LoginPass.vue